import { TreeItemType } from '@api';
import { FileTreeContextMenu, formatDate, ItemInstanceType } from '@common';
import { faFolderClosed, faFolderOpen } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Group, Input, Menu, Table, Text } from '@mantine/core';
import { ContextMenuActionIcon } from '../../common';

type FolderItemPropsType = {
  item: ItemInstanceType<TreeItemType>;
  canWrite: boolean;
  onAddFolder: () => void;
  onAddFile: () => void;
  onDelete: (item: TreeItemType) => void;
  isHovered: boolean;
};

export const FolderItem: React.FC<FolderItemPropsType> = ({
  item,
  canWrite,
  onAddFolder,
  onAddFile,
  onDelete,
  isHovered,
}) => {
  const icon = item.isExpanded() ? faFolderOpen : faFolderClosed;

  const childrenCount = item.getItemData().children?.length ?? 0;

  const date = formatDate(item.getItemData().lastModified);
  const isRenaming = item.isRenaming();

  const isEditable = canWrite && item.getItemData().isEditable;

  return (
    <>
      <Table.Td pl={item.getItemMeta().level * 30}>
        <Group gap="xs" id={item.getId()} p={5}>
          <FontAwesomeIcon icon={icon} color="#64748B" />
          {isRenaming ? (
            <Input {...item.getRenameInputProps()} size="xs" />
          ) : (
            <Text>
              {item.getItemName()} ({childrenCount})
            </Text>
          )}
        </Group>
      </Table.Td>
      <Table.Td>
        <Text>{date}</Text>
      </Table.Td>
      <Table.Td />
      <Table.Td>
        {canWrite && (
          <Menu>
            <ContextMenuActionIcon visible={isHovered} />
            <Menu.Dropdown>
              <FileTreeContextMenu.CreateSubfolder onClick={onAddFolder} />
              <FileTreeContextMenu.UploadFile onClick={onAddFile} />
              {isEditable && (
                <FileTreeContextMenu.Rename
                  onClick={() => item.startRenaming()}
                />
              )}
              <FileTreeContextMenu.Divider />
              {isEditable && (
                <FileTreeContextMenu.Delete
                  onClick={() => onDelete(item.getItemData())}
                />
              )}
            </Menu.Dropdown>
          </Menu>
        )}
      </Table.Td>
    </>
  );
};
